export const ListaMixin = {
  data() {
    return {
      groups: [
        {
          id: '0',
          label: 'Início',
          route: '/documentacao',
          expanded: false,
          children: [],
        },
        {
          id: '1',
          label: 'Administração',
          route: '/documentacao/administracao',
          info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
          active: false,
          isGroupExpanded: false,
          selected: false,
          disabledLink: true,
          expanded: false,
          children: [
            {
              id: '1.1',
              label: 'Indicadores Previne Brasil',
              route: '/documentacao/administracao/indicadores-previne-brasil',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              children: [],
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
            },
            {
              id: '1.2',
              label: 'Gerenciar Usuários',
              route: '/documentacao/administracao/gerenciar-usuarios',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              children: [],
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
            },
            {
              id: '1.3',
              label: 'Ressincronizacao',
              route: '/documentacao/administracao/ressincronizacao',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              children: [],
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
            },
            {
              id: '1.4',
              label: 'Gerenciar Permissões',
              route: '/documentacao/administracao/gerenciar-permissoes',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              children: [],
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
            },
          ],
        },
        {
          id: '1.5',
          label: 'Cadastros Cidadãos',
          route: '/documentacao/cadastros-cidadaos',
          info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
          active: false,
          isGroupExpanded: false,
          selected: false,
          children: [],
          disabledLink: true,
          expanded: false,
        },
        {
          id: '1.6',
          label: 'Gestão Cadastros',
          route: '/documentacao/gestao-cadastros',
          info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
          active: false,
          isGroupExpanded: false,
          selected: false,
          disabledLink: true,
          expanded: false,
          children: [
            {
              id: '1.6.1',
              label: 'Cidadão',
              route: '/documentacao/gestao-cadastros/acs-por-cidadao',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
              children: [],
            },
            {
              id: '1.6.2',
              label: 'Busca Ativa Cadastro',
              route: '/documentacao/gestao-cadastros/busca-ativa-cadastro',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
              children: [],
            },
            {
              id: '1.6.3',
              label: 'Cidadãos Duplicados',
              route: '/documentacao/gestao-cadastros/cidadaos-duplicados',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
              children: [],
            },
            {
              id: '1.6.4',
              label: 'Cadastros Sem Cpf',
              route: '/documentacao/gestao-cadastros/cadastros-sem-cpf',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
              children: [],
            },
          ],
        },
        {
          id: '1.7',
          label: 'Visitas Domiciliares',
          route: '/documentacao/visitas-domiciliares',
          info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
          active: false,
          isGroupExpanded: false,
          selected: false,
          disabledLink: true,
          expanded: false,
          children: [
            {
              id: '1.7.1',
              label: 'Cidadãos Visitados',
              route: '/documentacao/visitas-domiciliares/cidadaos-visitados',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
              children: [],
            },
            {
              id: '1.7.2',
              label: 'Familias Visitadas',
              route: '/documentacao/visitas-domiciliares/familias-visitadas',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
              children: [],
            },
            {
              id: '1.7.3',
              label: 'Desempenho por microárea',
              route:
                '/documentacao/visitas-domiciliares/desempenho-por-microarea',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              selected: false,
              child: true,
              disabledLink: false,
              children: [],
            },
          ],
        },
        {
          id: '2',
          label: 'Atendimentos no Mês',
          route: '/documentacao/atendimentos-no-mes',
          info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
          active: false,
          isGroupExpanded: false,
          selected: false,
          disabledLink: false,
          children: [],
          expanded: false,
        },
        {
          id: '3',
          label: 'Envio APP ACS PEC',
          route: '/documentacao/envio-app-acs-pec',
          info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
          active: false,
          isGroupExpanded: false,
          selected: false,
          disabledLink: false,
          children: [],
          expanded: false,
        },
        {
          id: '4',
          label: 'Informatiza APS',
          route: '/documentacao/informatiza-aps',
          info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
          active: false,
          isGroupExpanded: false,
          selected: false,
          disabledLink: false,
          children: [],
          expanded: false,
        },
        {
          id: '5',
          label: 'Indicadores APS',
          route: '/documentacao/indicadores-aps',
          info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
          active: false,
          isGroupExpanded: false,
          selected: false,
          disabledLink: true,
          expanded: false,
          children: [
            {
              id: '5.1',
              label: 'Citopatológico',
              route: '/documentacao/indicadores-aps/indicador-citologico',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              selected: false,
              isGroupExpanded: false,
              child: false,
              disabledLink: false,
              children: [],
            },
            {
              id: '5.2',
              label: 'Vacinas Pólio e Penta',
              route: '/documentacao/indicadores-aps/indicador-imunizacao',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              isGroupExpanded: false,
              selected: false,
              disabledLink: false,
              children: [],
            },
            {
              id: '5.3',
              label: 'Pré-natal',
              route: '/documentacao/indicadores-aps/pre-natal',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              isGroupExpanded: false,
              selected: false,
              disabledLink: true,
              expanded: false,
              children: [
                {
                  id: '5.3.1',
                  label: 'Consultas Pré-Natal',
                  route:
                    '/documentacao/indicadores-aps/pre-natal/consultas-pre-natal',
                  info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                  active: false,
                  isGroupExpanded: false,
                  selected: false,
                  disabledLink: false,
                  children: [],
                },
                {
                  id: '5.3.2',
                  label: 'Problemas ativos',
                  route:
                    '/documentacao/indicadores-aps/pre-natal/problemas-ativos',
                  info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                  active: false,
                  isGroupExpanded: false,
                  selected: false,
                  disabledLink: false,
                  children: [],
                },
                {
                  id: '5.3.3',
                  label: 'Consultas Odontológicas',
                  route:
                    '/documentacao/indicadores-aps/pre-natal/consultas-odontologicas',
                  info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                  active: false,
                  isGroupExpanded: false,
                  selected: false,
                  disabledLink: false,
                  children: [],
                },
                {
                  id: '5.3.4',
                  label: 'Exames HIV e Sífilis',
                  route:
                    '/documentacao/indicadores-aps/pre-natal/exames-hiv-sifilis',
                  info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                  active: false,
                  isGroupExpanded: false,
                  selected: false,
                  disabledLink: false,
                  children: [],
                },
                {
                  id: '5.3.5',
                  label: 'Os 3 Indicadores de Pré-natal',
                  route:
                    '/documentacao/indicadores-aps/pre-natal/tres-indicadores-pre-natal',
                  info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                  active: false,
                  isGroupExpanded: false,
                  selected: false,
                  disabledLink: false,
                  children: [],
                },
              ],
            },
            {
              id: '5.4',
              label: 'Doenças crônicas',
              route: '/documentacao/indicadores-aps/doencas-cronicas',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              isGroupExpanded: false,
              selected: false,
              disabledLink: true,
              expanded: false,
              children: [
                {
                  id: '5.4.1',
                  label: 'Atendimento Diabetes',
                  route:
                    '/documentacao/indicadores-aps/doencas-cronicas/atendimento-diabetes',
                  info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                  active: false,
                  isGroupExpanded: false,
                  selected: false,
                  disabledLink: false,
                  children: [],
                },
                {
                  id: '5.4.2',
                  label: 'Atendimento Hipertensão',
                  route:
                    '/documentacao/indicadores-aps/doencas-cronicas/atendimento-hipertensao',
                  info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                  active: false,
                  isGroupExpanded: false,
                  selected: false,
                  disabledLink: false,
                  children: [],
                },
                // {
                //   id: '5.4.3',
                //   label: 'Hiper Dia',
                //   route:
                //     '/documentacao/indicadores-aps/doencas-cronicas/hiper-dia',
                //   info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                //   active: false,
                //   isGroupExpanded: false,
                //   selected: false,
                //   disabledLink: false,
                //   children: [],
                // },
              ],
            },
            {
              id: '5.5',
              label: 'Resultado Isf',
              route: '/documentacao/indicadores-aps/resultado-isf-acs',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              isGroupExpanded: false,
              selected: false,
              disabledLink: false,
              children: [],
            },
            {
              id: '5.6',
              label: 'Desempenho Por Equipe',
              route: '/documentacao/indicadores-aps/desempenho-por-equipe',
              info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
              active: false,
              isGroupExpanded: false,
              selected: false,
              disabledLink: true,
              expanded: false,
              children: [
                {
                  id: '5.6.1',
                  label: 'Por Indicador',
                  route:
                    '/documentacao/indicadores-aps/desempenho-por-equipe/indicador',
                  info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                  active: false,
                  isGroupExpanded: false,
                  selected: false,
                  disabledLink: false,
                  children: [],
                },
                {
                  id: '5.6.2',
                  label: 'Geral',
                  route:
                    '/documentacao/indicadores-aps/desempenho-por-equipe/geral',
                  info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
                  active: false,
                  isGroupExpanded: false,
                  selected: false,
                  disabledLink: false,
                  children: [],
                },
              ],
            },
          ],
        },
        {
          id: '6',
          label: 'Risco Cardiovascular',
          route: '/documentacao/risco-cardio-vascular',
          info: 'e-SUS Atenção Primária à Saúde: Manual  do Sistema com Prontuário Eletrônico do Cidadão PEC – Versão',
          active: false,
          isGroupExpanded: false,
          selected: false,
          disabledLink: false,
          children: [],
          expanded: false,
        },
      ],
    }
  },
}
